import React from 'react';
import { ICoreContext } from '@msdyn365-commerce/core';
import { formatDate, formatNumber } from '../../../utilities';
import { ILxsCreateOrderResources } from '../../lxs-create-order/lxs-create-order.props.autogenerated';
import { ILxsOrderData } from '../lxs-create-order.data';
import { formatPriceIndication } from '../../../utilities/format-price-indication';
import Tooltip from '../../../components/tooltip';

export default function orderItems({
    context,
    itemsData,
    resources,
    productsHaveEndcustomers
}: {
    context: ICoreContext;
    itemsData: ILxsOrderData;
    resources: ILxsCreateOrderResources;
    productsHaveEndcustomers: boolean;
}) {
    return (
        <>
            <h3 className='ms-order-details__section-heading'>{resources.createOrderItemsHeading}</h3>
            <div className='table-responsive'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>{resources.createOrderItemsTablePosition}</th>
                            <th>{resources.createOrderItemsTableProductName}</th>
                            <th>{resources.createOrderItemsTableProductNumber}</th>
                            <th>{resources.createOrderSelectedProductsTableRequestedDeliveryDate}</th>
                            <th>{resources.createOrderSelectedProductsReqQuantity}</th>
                            <th>
                                <Tooltip
                                    label={resources.createOrderProductsTablePriceTitle}
                                    content={resources.createOrderProductsTablePriceInformation}
                                />
                            </th>
                            {productsHaveEndcustomers && <th>{resources.createOrderSelectedProductsTableEndCustomer}</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {itemsData?.products?.map((item, index) => (
                            <tr key={index}>
                                <td>{(index + 1) * 10}</td>
                                <td>{item.ProductName}</td>
                                <td>{item.ProductNumber}</td>
                                <td>{formatDate(context, new Date(item.RequestedDate))}</td>
                                <td>{`${formatNumber(context, Number(Number(item.Quantity).toFixed(3)))} ${item.UnitOfMeasure}`}</td>
                                {item.PriceMissing ? (
                                    <td>{resources.createOrderProductsTablePriceIndicationNotAvailableMessage}</td>
                                ) : (
                                    <td>{formatPriceIndication(item)}</td>
                                )}
                                {productsHaveEndcustomers && <td>{item.EndCustomerName}</td>}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}
